import React from 'react';
import { MapModal } from '@yme/components/CheckoutForm/MapModal';
import { ReviewModal } from '@yme/components/CheckoutForm/ReviewForm/ReviewModal';
import { ConfirmationDeletingModal } from '@yme/components/ShoppingCart/ConfirmationDeletingModal';
import { ErrorModalWindow as ShoppingCartError } from '@yme/components/ShoppingCart/ErrorModalWindow';
import { GenerateQrErrorModal } from '@yme/components/ShoppingCart/GenerateQrErrorModal';
import { ResetSessionModal } from '@yme/components/ShoppingCart/ResetSessionModal';
import { ShareCartByEmailModal } from '@yme/components/ShoppingCart/ShareCartByEmailModal';
import { ShareCartByQrModal } from '@yme/components/ShoppingCart/ShareCartByQrModal';
import { RedemptionCodeModal } from '@yme/modals/RedemptionCodeModal';
import { ResetModelModal } from '@yme/modals/ResetModelModal';
import { TerminalPaymentModal } from '@yme/modals/TerminalPaymentModal';
import { TerminalWrongOrderModal } from '@yme/modals/TerminalWrongOrderModal';
import { ConfiguratorModalWindow } from '@yme/pdp-components/ConfiguratorModal';
import { AlertMessageModal } from './AlertMessageModal';
import { AnotherSessionModal } from './AnotherSessionModal';
import { ComparisonRemoveModelModal } from './ComparisonRemoveModelModal';
import { FlipToLandscapeModal } from './FlipToLandscapeModal';
import { GeneralMessageModal } from './GeneralMessageModal';
import { LoginRequiredModal } from './LoginRequiredModal';
import { MapModal as MapModalNew } from './MapModal';
import { NewsletterModal } from './NewsletterModal';
import { ProceedToCartModal } from './ProceedToCartModal';
import { RedirectionExternalCartModal } from './RedirectionExternalCartModal';
import { RequiredPartVariantModal } from './RequiredPartVariantModal';
import { RequiredPartsInfoModal } from './RequiredPartsInfoModal';
import { SelectYourModelModal } from './SelectYourModelModal';
import { MODALS } from './constants';
export const modalWindowsMapping = {
    [MODALS.CONFIGURATOR_MODAL]: React.createElement(ConfiguratorModalWindow, null),
    [MODALS.SHOPPING_CART_ERROR]: React.createElement(ShoppingCartError, null),
    [MODALS.CONFIRMATION_DELETING_MODAL]: React.createElement(ConfirmationDeletingModal, null),
    [MODALS.GENERAL_MESSAGE_MODAL]: React.createElement(GeneralMessageModal, null),
    [MODALS.CHECKOUT_REVIEW_MODAL]: React.createElement(ReviewModal, null),
    [MODALS.RESET_SESSION_MODAL]: React.createElement(ResetSessionModal, null),
    [MODALS.SHARE_CART_BY_QR_MODAL]: React.createElement(ShareCartByQrModal, null),
    [MODALS.MAP_MODAL]: React.createElement(MapModal, null),
    [MODALS.MAP_MODAL_NEW]: React.createElement(MapModalNew, null),
    [MODALS.ANOTHER_SESSION_MODAL]: React.createElement(AnotherSessionModal, null),
    [MODALS.SHARE_CART_BY_EMAIL_MODAL]: React.createElement(ShareCartByEmailModal, null),
    [MODALS.GENERATE_QR_ERROR_MODAL]: React.createElement(GenerateQrErrorModal, null),
    [MODALS.SELECT_YOUR_MODEL_MODAL]: React.createElement(SelectYourModelModal, null),
    [MODALS.PROCEED_TO_CART_MODAL]: React.createElement(ProceedToCartModal, null),
    [MODALS.LOGIN_REQUIRED_MODAL]: React.createElement(LoginRequiredModal, null),
    [MODALS.REQUIRED_PART_VARIANT_MODAL]: React.createElement(RequiredPartVariantModal, null),
    [MODALS.RESET_MODEL_MODAL]: React.createElement(ResetModelModal, null),
    [MODALS.ALERT_MESSAGE_MODAL]: React.createElement(AlertMessageModal, null),
    [MODALS.REDIRECTION_EXTERNAL_CART_MODAL]: React.createElement(RedirectionExternalCartModal, null),
    [MODALS.COMPARISON_REMOVE_MODEL_MODAL]: React.createElement(ComparisonRemoveModelModal, null),
    [MODALS.FLIP_TO_LANDSCAPE_MODAL]: React.createElement(FlipToLandscapeModal, null),
    [MODALS.REQUIRED_PARTS_INFO_MODAL]: React.createElement(RequiredPartsInfoModal, null),
    [MODALS.NEWSLETTER_MODAL]: React.createElement(NewsletterModal, null),
    [MODALS.REDEMPTION_CODE_MODAL]: React.createElement(RedemptionCodeModal, null),
    [MODALS.TERMINAL_PAYMENT_MODAL]: React.createElement(TerminalPaymentModal, null),
    [MODALS.TERMINAL_WRONG_ORDER_MODAL]: React.createElement(TerminalWrongOrderModal, null),
};
